export default __webpack_public_path__ + "static/media/image_1.2a55b49a.jpg";